export const rental_car = {
  namespaced: true,
  state: {
    rental_car: {},
  },
  getters: {
    rental_car(state) {
      return state.rental_car;
    },
  },
  mutations: {
    setRentalCar(state, info) {
      state.rental_car = info;
    },
  },
  actions: {
    // カーシェア情報を緯度経度から取得
    async getRentalCar(context, { geo }) {
      var params = {};
      console.log("context.dispatch :>> ", context);
      const resp = await context.dispatch(
        "common/getRequest",
        {
          path: `search-rentacar?geo_point=${geo}`,
          bodyParams: params,
        },
        { root: true }
      );
      console.log(
        "getRentalCar resp.data.ResultSet.Point[0] :>> ",
        resp.data.ResultSet.Point[0]
      );
      return resp.data.ResultSet.Point[0];
    },
  },
};
